<footer class="bg-white">
	<div class="w-full max-w-screen-xl px-3 py-20 mx-auto seccion_informacion">
		<div class="flex divide-x footer-division">
			<div class="pr-8 mb-6 md:mb-0 seccion-logo">
				<a routerLink="/" class="flex items-center justify-center">
					<img src="/images/logo.png" alt="Logo Movil Bus" />
				</a>
				<hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-4" />
				<div class="flex justify-center gap-3">
					<div>
						<a href="https://www.facebook.com/MovilBus.pe" target="_blank"
							><img src="/images/facebook.png" alt="Facebook Movil Bus"
						/></a>
					</div>
					<div>
						<a href="https://www.youtube.com/@MovilBusPeru" target="_blank"
							><img src="/images/youtube.png" alt="Youtube Movil Bus"
						/></a>
					</div>
					<div>
						<a href="https://www.tiktok.com/@movilbuspe" target="_blank"
							><img width="35" src="/images/tiktok.png" alt="TikTok Movil Bus"
						/></a>
					</div>
					<div>
						<a href="https://www.linkedin.com/company/movil-bus/" target="_blank"
							><img src="/images/linking.png" alt="Linkedin Movil Bus"
						/></a>
					</div>
					<div>
						<a href="https://www.instagram.com/movilbus.pe/" target="_blank"
							><img src="/images/instagram.png" alt="Instagram Movil Bus"
						/></a>
					</div>
				</div>
				<hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-4" />
				<div class="mt-6 seccion-direccion">
					<p class="mb-2 text-black font-ubuntu text-f14">Dirección: Av. Nicolás Arriola 740, Lima, Perú</p>
					<p class="mb-2 text-black font-ubuntu text-f14">
						Central telefónica:
						<a href="https://api.whatsapp.com/send?phone=5117168000&text=" target="_blank">01 716 8000</a>
					</p>
					<p class="mb-2 text-black font-ubuntu text-f14">
						Correo electrónico: <a href="mailto:info&#64;movilbus.pe" target="_blank">info&#64;movilbus.pe</a>
					</p>
				</div>
			</div>
			<div class="grid grid-cols-4 gap-8 sm:gap-12 items_footer pl-11">
				<div>
					<h2 class="text-sm font-medium text-black font-ubuntu text-f16">Enlaces</h2>
					<hr class="border-[1.5px] mt-3 mb-2" />
					<ul>
						<ul *ngIf="menuEnlaces && menuEnlaces[0]?.items">
							@for (item of menuEnlaces[0].items; track $index) {
								@if (item.nueva_ventana) {
									<li
										[ngClass]="{
											'flex items-center justify-center space-x-1': item.nombre === 'Libro de reclamaciones'
										}"
									>
										@if (item.nombre == 'Libro de reclamaciones') {
											<span style="border: 1px solid #000"><img width="70" src="/images/libro.png" /></span>
										}
										<a target="_blank" [href]="item.url_personalizada || item.url">{{ item.nombre }}</a>
									</li>
								} @else {
									<li routerLinkActive="active">
										<a [href]="item.url_personalizada || item.url">{{ item.nombre }}</a>
									</li>
								}
							}
						</ul>
						<!-- <li>
							<a routerLink="/nosotros" class="hover:underline">Nosotros</a>
						</li>
						<li>
							<a routerLink="/preguntas-frecuentes" class="hover:underline">Preguntas frecuentes</a>
						</li>
						<li>
							<a href="http://fe.moviltours.com.pe/boletaCliente/" target="_blank" class="hover:underline"
								>Facturación electrónica</a
							>
						</li>
						<li>
							<a routerLink="/page/clausulas-de-viaje" class="hover:underline">Cláusulas de viaje</a>
						</li>
						<li>
							<a routerLink="/page/clausulas-de-encomiendas" class="hover:underline">Cláusulas de encomiendas</a>
						</li>
						<li>
							<a
								href="https://www.movilbus.pe/wp-content/uploads/2024/03/CODIGO_DE_ETICA_BUENA_CONDUCTA_VF.pdf"
								class="hover:underline"
								>Código de ética y buena conducta</a
							>
						</li>
						<li>
							<a href="https://movilbus.sherlockhr.com/" class="hover:underline" target="_blank"
								>Trabaja con nosotros</a
							>
						</li>
						<li>
							<a href="https://librovirtual.pe/r/movilbus" target="_blank" class="hover:underline"
								>Libro de reclamaciones</a
							>
						</li> -->
					</ul>
				</div>
				<div>
					<h2 class="text-sm font-medium text-black font-ubuntu text-f16">Enlaces</h2>
					<hr class="border-[1.5px] mt-3 mb-2" />
					<ul *ngIf="menuEnlaces2 && menuEnlaces2[0]?.items">
						@for (item of menuEnlaces2[0]!.items || []; track $index) {
							@if (item.nueva_ventana) {
								<li
									[ngClass]="{ 'flex items-center justify-center space-x-1': item.nombre === 'Libro de reclamaciones' }"
								>
									@if (item.nombre == 'Libro de reclamaciones') {
										<span style="border: 1px solid #000"><img width="70" src="/images/libro.png" /></span>
									}
									<a target="_blank" [href]="item.url_personalizada || item.url">{{ item.nombre }}</a>
								</li>
							} @else {
								<li routerLinkActive="active">
									<a [href]="item.url_personalizada || item.url">{{ item.nombre }}</a>
								</li>
							}
						}
					</ul>
				</div>
				<div>
					<h2 class="text-sm font-medium text-black font-ubuntu text-f16">Rutas frecuentes</h2>
					<hr class="border-[1.5px] mt-3 mb-2" />
					<ul *ngIf="menuRutasFrecuentes1 && menuRutasFrecuentes1[0]?.items">
						@for (item of menuRutasFrecuentes1[0]!.items || []; track $index) {
							@if (item.nueva_ventana) {
								<li
									[ngClass]="{ 'flex items-center justify-center space-x-1': item.nombre === 'Libro de reclamaciones' }"
								>
									<a target="_blank" [href]="item.url_personalizada || 'viajar-bus/' + item.url">{{ item.nombre }}</a>
								</li>
							} @else {
								<li routerLinkActive="active">
									<a [href]="item.url_personalizada || 'viajar-bus/' + item.url">{{ item.nombre }}</a>
								</li>
							}
						}
					</ul>
				</div>
				<div>
					<h2 class="text-sm font-medium text-black font-ubuntu text-f16">Rutas frecuentes</h2>
					<hr class="border-[1.5px] mt-3 mb-2" />
					<ul *ngIf="menuRutasFrecuentes2 && menuRutasFrecuentes2[0]?.items">
						@for (item of menuRutasFrecuentes2[0]!.items || []; track $index) {
							@if (item.nueva_ventana) {
								<li
									[ngClass]="{ 'flex items-center justify-center space-x-1': item.nombre === 'Libro de reclamaciones' }"
								>
									<a target="_blank" [href]="item.url_personalizada || 'viajar-bus/' + item.url">{{ item.nombre }}</a>
								</li>
							} @else {
								<li routerLinkActive="active">
									<a [href]="item.url_personalizada || 'viajar-bus/' + item.url">{{ item.nombre }}</a>
								</li>
							}
						}
					</ul>
				</div>
			</div>
		</div>
	</div>
	<div class="flex items-center justify-center bg-[#4D4D4D] p-3">
		<span class="text-center text-white text-f13">© Movil Bus - {{ anioActual }} Derechos reservados.</span>
	</div>
</footer>
